// extracted by mini-css-extract-plugin
export default {"cardTitleWrapper":"styles_cardTitleWrapper__SSCo-","preTitle":"styles_preTitle__q22E0"};